import getConfig from 'next/config';
import {useMemo} from 'react';

export enum STRIPE_ENV {
  DEV = 'development',
  QA = 'qa',
  PREPROD = 'preprod',
  PROD = 'production',
}

export interface SharedConfig {
  STRIPE_ENV: STRIPE_ENV;
}

export function isServer(): boolean {
  return typeof window === 'undefined';
}

function getEnvConfig(): SharedConfig {
  // NB: It's important getConfig() is
  // lazily resolved here because it's
  // provided by NextJS and very well
  // may not be defined in tests
  if (isServer()) {
    return getConfig().serverRuntimeConfig;
  } else {
    return getConfig().publicRuntimeConfig;
  }
}

export function getStripeEnv(): STRIPE_ENV {
  return getEnvConfig().STRIPE_ENV;
}

export function useStripeEnv() {
  return useMemo(() => getStripeEnv(), []);
}

export function useIsServer() {
  return useMemo(() => isServer(), []);
}

export function useIsProduction() {
  return useMemo(() => getStripeEnv() === STRIPE_ENV.PROD, []);
}
